
    /* eslint-disable */
    // @ts-nocheck
    // @ts-ignore
    var __STORY__ = "import { useEffect } from '@storybook/client-api';\n\nimport { createElasticTextArea } from '../../components/input/elastic-textarea.ts';\n\nimport contactA from './contact-a.twig';\nimport contactB from './contact-b.twig';\nimport contactC from './contact-c.twig';\nimport './contact-a.scss';\nimport './contact-b.scss';\nimport './contact-c.scss';\n\nexport default {\n  title: 'Prototypes/Contact',\n  parameters: {\n    docs: { page: null },\n    layout: 'fullscreen',\n  },\n};\n\nconst sharedEffect = () => {\n  createElasticTextArea(document.querySelector('.js-elastic-textarea'));\n};\n\nexport const ContactA = () => {\n  useEffect(sharedEffect, []);\n  return contactA();\n};\n\nexport const ContactB = () => {\n  useEffect(sharedEffect, []);\n  return contactB();\n};\n\nexport const ContactC = () => {\n  useEffect(sharedEffect, []);\n  return contactC();\n};\n";
    // @ts-ignore
    var __LOCATIONS_MAP__ = {"ContactA":{"startLoc":{"col":24,"line":24},"endLoc":{"col":1,"line":27},"startBody":{"col":24,"line":24},"endBody":{"col":1,"line":27}},"ContactB":{"startLoc":{"col":24,"line":29},"endLoc":{"col":1,"line":32},"startBody":{"col":24,"line":29},"endBody":{"col":1,"line":32}},"ContactC":{"startLoc":{"col":24,"line":34},"endLoc":{"col":1,"line":37},"startBody":{"col":24,"line":34},"endBody":{"col":1,"line":37}}};
    
import { useEffect } from '@storybook/client-api';

import { createElasticTextArea } from '../../components/input/elastic-textarea.ts';

import contactA from './contact-a.twig';
import contactB from './contact-b.twig';
import contactC from './contact-c.twig';
import './contact-a.scss';
import './contact-b.scss';
import './contact-c.scss';

export default {
  title: 'Prototypes/Contact',
  parameters: {
    docs: { page: null },
    layout: 'fullscreen',
  },
};

const sharedEffect = () => {
  createElasticTextArea(document.querySelector('.js-elastic-textarea'));
};

export const ContactA = () => {
  useEffect(sharedEffect, []);
  return contactA();
};;

export const ContactB = () => {
  useEffect(sharedEffect, []);
  return contactB();
};;

export const ContactC = () => {
  useEffect(sharedEffect, []);
  return contactC();
};



ContactA.parameters = { storySource: { source: "() => {\n  useEffect(sharedEffect, []);\n  return contactA();\n}" }, ...ContactA.parameters };
ContactB.parameters = { storySource: { source: "() => {\n  useEffect(sharedEffect, []);\n  return contactB();\n}" }, ...ContactB.parameters };
ContactC.parameters = { storySource: { source: "() => {\n  useEffect(sharedEffect, []);\n  return contactC();\n}" }, ...ContactC.parameters };